var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationSolid = function SvgExclamationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 20.25A3.754 3.754 0 0 1 12 24a3.754 3.754 0 0 1-3.75-3.75A3.754 3.754 0 0 1 12 16.5a3.754 3.754 0 0 1 3.75 3.75M8.684 1.181l.638 12.75c.03.599.524 1.069 1.123 1.069h3.11c.6 0 1.094-.47 1.123-1.069l.638-12.75A1.125 1.125 0 0 0 14.192 0H9.808c-.644 0-1.156.539-1.124 1.181"
  })));
};
export default SvgExclamationSolid;